/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'number',
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'object',
  properties: {
    min: {oneOf: [{type: 'number', minimum: 0}, {type: 'null'}]},
    max: {oneOf: [{type: 'number', minimum: 0}, {type: 'null'}]},
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    number_of_diverse_workers_under_18: valueSchema,
  },
}
